module.exports = "/shiftTasks/components/taskTemplates/taskTemplatesHeaderButtons-58ef97.html";